import { useSelector } from 'react-redux';
import { isAiNotesEnabled } from './functions';
import AiNotesButton from './components/web/AiNotesButton';
const aiNotesButton = {
    key: 'ainotes',
    Content: AiNotesButton,
    group: 2
};
/**
 * 「更多」菜单 AI 纪要按钮（仅 aiNotes.enabled 时出现）.
 *
 * @returns {Object | undefined}
 */
export function useAiNotesButton() {
    const enabled = useSelector(isAiNotesEnabled);
    if (!enabled) {
        return undefined;
    }
    return aiNotesButton;
}
